import { connect } from 'react-redux'
import requestSendMessage from '../../sagas/requestSendMessage'
import messageSelector from './messageSelector'
import Message from './Message'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  messageSelector,
  {
    requestSendMessage,
  }
)(Message))
